module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DSelect', {
    attrs: {
      "items": _vm.itemsFiltered,
      "itemsSelected": _vm.itemsSelectedFormatted,
      "placeholder": "Tilføj underviser",
      "isDeleteAllAnOption": false,
      "show": true
    },
    on: {
      "update": _vm.update,
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "noMatch"
    },
    slot: "noMatch"
  }, [_vm._v("Ingen personer matcher")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-285c688c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetningKlasserDSelect.vue
// module id = 1554
// module chunks = 1